import { useContext } from "react";
import { CarbonContext } from "../CarbonContext";
import { useNavigate } from "react-router-dom";

const Car = ({ cars, isOrder }) => {
  const { token } = useContext(CarbonContext);
  const navigate = useNavigate();

  const submitOrder = async ({ _id, name, price, image }) => {
    if (!token.access_token) {
      navigate("/");
    }

    const orderData = {
      _id,
      name,
      price,
      image,
    };

    try {
      const response = await fetch("https://carbon-j654.onrender.com/api/order", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.access_token}`,
        },
        body: JSON.stringify(orderData),
      });

      if (response.ok) {
        window.alert(
          "Order Successful! Thank you for your purchase. Your car will be delivered to your address soon."
        );
        navigate("/orders");
      } else {
        window.alert("Order Failed! There was an issue with your purchase.");
      }
    } catch (error) {
      console.error("Error sending order:", error);
    }
  };

  return (
    <>
      {cars.map((car) => (
        <div key={car._id} className="border-b border-neutral-900">
          <div className="relative h-[60vh] md:h-[80vh] w-full">
            <div
              className="absolute inset-0 z-0"
              style={{
                backgroundImage: `url(${car.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="absolute inset-0 bg-black/50" />
            </div>

            <div className="relative z-10 h-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="flex flex-col justify-center h-full max-w-xl">
                <h1 className="text-4xl md:text-6xl font-bold text-white mb-4">
                  {car.name}
                </h1>

                <div className="mb-8">
                  <span className="text-2xl md:text-4xl font-semibold text-white">
                    Starting from
                  </span>
                  <div className="text-3xl md:text-5xl font-bold text-white">
                    ${car.price}
                  </div>
                </div>

                {!isOrder ? (
                  <button
                    className="bg-white text-gray-900 hover:bg-gray-100 transition-colors duration-300 rounded-md px-8 py-3 text-lg font-semibold w-fit"
                    onClick={() => submitOrder(car)}
                  >
                    Order Now
                  </button>
                ) : (
                  <div className="text-white text-4xl font-bold">
                    Order Successful!
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default Car;
